export default function FolderTile({ active, onClick, icon, label, count, testId, actions }) {
  // Root is a <div role="button"> (not <button>) so that the nested
  // rename/delete icon buttons in `actions` remain valid HTML and
  // a11y-correct. Keyboard activation (Enter/Space) is wired manually.
  const handleKey = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick?.();
    }
  };
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKey}
      data-testid={testId}
      className={`w-full cursor-pointer text-left flex items-center justify-between gap-2 px-2.5 py-2 rounded-md transition border focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37]/55 ${
        active
          ? "border-[#D4AF37]/40 bg-gradient-to-r from-[#D4AF37]/15 to-transparent text-white"
          : "border-transparent hover:border-white/10 hover:bg-white/[0.04] text-white/75"
      }`}
    >
      <span className="flex items-center gap-2 min-w-0">
        <span className={active ? "text-[#D4AF37]" : "text-white/40"}>{icon}</span>
        <span className="truncate text-sm">{label}</span>
      </span>
      <span className="flex items-center gap-1.5 shrink-0">
        {actions && <span className="hidden group-hover/folder:flex items-center gap-1">{actions}</span>}
        <span className={`text-[10px] tabular-nums ${active ? "text-[#D4AF37]" : "text-white/35"}`}>{count ?? 0}</span>
      </span>
    </div>
  );
}
